export default __webpack_public_path__ + "static/batiments2b_pruned-e694da7e46bd7f2fd4a857142e51f95e.webp";